module.exports = __webpack_public_path__ + "img/light.0bafc8aa.svg";